var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: [
        _vm.$style.loader,
        ((_obj = {}), (_obj[_vm.$style.overlay] = _vm.overlay), _obj),
      ],
    },
    [
      _c(
        "svg",
        {
          class: _vm.$style.ring,
          attrs: { viewBox: "25 25 50 50", "stroke-width": "5" },
        },
        [_c("circle", { attrs: { cx: "50", cy: "50", r: "20" } })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }